<template>
  <div>
    <el-menu
      :collapse="isCollapse"
      :collapse-transition="false"
      :default-active="defaultActive"
      active-text-color="#165BCF"
      class="menu_cls base-flex base-flex__column-around"
      open="0"
    >
      <div class="base-flex__1">
        <el-menu-item index="0" @click="jumpPage('dashboard', 0)">
          <i class="el-icon-odometer"/>
          <span slot="title">{{ $t('menu.dashboard') }}</span>
        </el-menu-item>
        <el-menu-item-group v-show="hideMenu" :title="isCollapse ? '' : $t('menu.cluster.title')">
          <div v-if="isCollapse" class="line"/>
          <el-menu-item index="1" @click="jumpPage('computingCluster', 1)">
            <i class="el-icon-cpu"/>
            <span slot="title">{{ $t('menu.cluster.computing') }}</span>
          </el-menu-item>
          <el-menu-item index="2" @click="jumpPage('customList', 2)">
            <i class="el-icon-set-up"/>
            <span slot="title">{{ $t('menu.cluster.custom') }}</span>
          </el-menu-item>
          <el-menu-item index="16" @click="jumpPage('multiCloudCluster', 16)">
            <i class="el-icon-cloudy"/>
            <span slot="title">{{ $t('menu.cluster.multiCloud') }}</span>
          </el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group v-show="hideMenu" :title="isCollapse ? '' : $t('menu.account.title')">
          <div v-if="isCollapse" class="line"/>
          <el-menu-item index="4" @click="jumpPage('team', 4)">
            <i class="el-icon-s-custom"></i>
            <span slot="title">{{ $t('menu.account.member') }}</span>
          </el-menu-item>
          <el-menu-item class="task" index="15" @click="jumpPage('approval', 15)">
            <i class="el-icon-folder-checked"/>
            <span slot="title">{{ $t('menu.cluster.approval') }}</span>
          </el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group v-if="isAdmin === '1'" :title="isCollapse ? '' : $t('menu.admin.title')">
          <div v-if="isCollapse" class="line"/>
          <el-menu-item index="6" @click="jumpPage('backstage', 6)">
            <i class="el-icon-key"></i>
            <span slot="title">{{ $t('menu.admin.license') }}</span>
          </el-menu-item>
          <el-menu-item index="7" @click="jumpPage('mirrorManagement', 7)">
            <i class="el-icon-document-remove"></i>
            <span slot="title">{{ $t('menu.admin.mirror') }}</span>
          </el-menu-item>
          <el-menu-item index="8" @click="jumpPage('configManagement', 8)">
            <i class="el-icon-setting"></i>
            <span slot="title">{{ $t('menu.admin.config') }}</span>
          </el-menu-item>
          <el-menu-item index="9" @click="jumpPage('ipManagement', 9)">
            <i class="el-icon-mobile-phone"></i>
            <span slot="title">{{ $t('menu.admin.whitelist') }}</span>
          </el-menu-item>
          <el-menu-item index="10" @click="jumpPage('authorization', 10)">
            <i class="el-icon-headset"></i>
            <span slot="title">{{ $t('menu.admin.appAuth') }}</span>
          </el-menu-item>
          <el-menu-item index="11" @click="jumpPage('administrator', 11)">
            <i class="el-icon-s-custom"></i>
            <span slot="title">{{ $t('menu.admin.user') }}</span>
          </el-menu-item>
          <el-menu-item index="12" @click="jumpPage('projectManagement', 12)">
            <i class="el-icon-coordinate"></i>
            <span slot="title">{{ $t('menu.admin.team') }}</span>
          </el-menu-item>
          <el-menu-item index="13" @click="jumpPage('availableApplications', 13)">
            <i class="el-icon-user"></i>
            <span slot="title">{{ $t('menu.admin.app') }}</span>
          </el-menu-item>
          <el-menu-item index="14" @click="jumpPage('describeOperation', 14)">
            <i class="el-icon-view"></i>
            <span slot="title">{{ $t('menu.admin.audit') }}</span>
          </el-menu-item>
          <el-menu-item v-if="false" index="17" @click="jumpPage('logManagement', 17)">
            <i class="el-icon-edit"></i>
            <span slot="title">{{ $t('menu.admin.log') }}</span>
          </el-menu-item>
          <el-menu-item index="18" @click="jumpPage('decodeWatermark', 18)">
            <i class="el-icon-video-camera"></i>
            <span slot="title">{{ $t('menu.admin.watermark') }}</span>
          </el-menu-item>
        </el-menu-item-group>
      </div>
      <div>
        <el-menu-item-group>
          <div class="base-height__60"></div>
          <el-menu-item
            :class="`${isCollapse ? 'menu_unfold_change' : 'menu_fold_change'}`"
            class="menu_unfold"
            @click="isCollapse = !isCollapse"
          >
            <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
            <span slot="title">{{ isCollapse ? $t('menu.toggle.expand') : $t('menu.toggle.collapse') }}</span>
          </el-menu-item>
        </el-menu-item-group>
      </div>
    </el-menu>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';

export default {
  name: 'menuList',
  data() {
    return {
      defaultActive: window.sessionStorage.getItem('menuIndex') || '0',
      isAdmin: window.sessionStorage.getItem('isAdmin') || '0',
      loginType: window.sessionStorage.getItem('loginType') || 'qq',
      hideMenu: true,
      isCollapse: true,
      defaultOverSize: 0,
    };
  },
  mounted() {
    this.defaultOverSize = document.body.scrollWidth;
    if (document.body.scrollWidth > 1600) {
      this.isCollapse = false;
    }
    window.addEventListener('resize', this.handleResize);

    window.onresize = () => {
      this.defaultOverSize = document.body.clientWidth;
    };

    const currentProject = this.getCurrentProject();
    this.hideMenu = JSON.stringify(currentProject) !== '{}';

    this.$eventBus.$on('viewAll', () => {
      document.querySelector('.task').click();
    });
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.menuSelectIndex'(val) {
      this.defaultActive = val.toString();
      window.sessionStorage.setItem('menuIndex', val);
    },
    'app.userInfo'(val) {
      window.sessionStorage.setItem('loginType', val.way);
      this.isAdmin = val.isAdmin.toString();
      this.loginType = val.way;
    },
    'app.projectList'(val) {
      this.hideMenu = val.length !== 0;
    },
  },
  methods: {
    jumpPage(val, index) {
      this.defaultActive = index.toString();
      this.$store.commit('app/setMenuSelectIndex', index);
      window.sessionStorage.setItem('menuIndex', index);
      if (this.$route.name !== val) {
        this.$router.push(val);
      }
    },
    handleResize() {
      this.defaultOverSize = document.body.scrollWidth;
    },
  },
  beforeDestroy() {
    this.$eventBus.$off('viewAll');
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.el-menu {
  height: 100%;
  border-right: none;

  ::v-deep .is-active {
    color: #165bcf;
  }
}

.menu_unfold {
  position: fixed;
  left: -9px;
  bottom: 0;
  background-color: #fff;
  transition: width 0.5s; /* 设置过渡效果 */
  padding-left: 29px !important;
  padding-right: 15px;
}

::v-deep .el-tooltip {
  padding: 0 !important;
  position: relative !important;
}

.menu_unfold_change {
  width: auto;
}

.menu_fold_change {
  width: 170px;
}

.menu_cls:not(.el-menu--collapse) {
  width: 170px;
  min-height: 600px;
  //::-webkit-scrollbar {
  //  display: none; /* Chrome Safari */
  //}
}

.el-menu-item-group {
  .el-menu-item-group__title .el-menu-item {
    padding-left: 20px !important;
  }
}

.img_cls {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}

.line {
  height: 1px; /* 高度为 1px */
  width: 66px; /* 宽度为 100% */
  background-color: #e9e9e9; /* 背景色为灰色 */
}
</style>
